<template>
  <Grid gtc="1fr 1fr 1fr" gap="var(--r-space-sp)" class="widgets">
    <component :is="component.type" v-for="(component, index) of definition" :key="component.id" :period-id="id">
      <template #widget-options>
        <q-btn flat round size="xs">
          <GearIcon :dark="component.type === 'stakeholder-responses'" />
          <RPopup :items="options" @popup-item="changeBoxContent($event, index)" />
        </q-btn>
      </template>
    </component>
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { cloneDeep } from 'lodash'
// Components
import GearIcon from '@/ui/icons/GearIcon'
import RPopup from '@/ui/RPopup'

export default {
  components: {
    EvaluationRatingsForCurrentAndPreviousPeriod: () => import('./EvaluationRatingsForCurrentAndPreviousPeriod'),
    PriceDevelopmentInOriginalCurrency: () => import('./PriceDevelopmentInOriginalCurrency'),
    PriceDevelopmentInLocalCurrency: () => import('./PriceDevelopmentInLocalCurrency'),
    StakeholderResponses: () => import('./StakeholderResponses'),
    CostPerUseInOriginalCurrency: () => import('./CostPerUseInOriginalCurrency'),
    CostPerUseInLocalCurrency: () => import('./CostPerUseInLocalCurrency'),
    UsageDevelopment: () => import('./UsageDevelopment'),
    GearIcon,
    RPopup
  },

  props: {
    id: [Number, String]
  },

  data: () => ({
    definition: []
  }),

  computed: {
    layout() {
      const layouts = this.$store.state.widgets.layout
      const subscriptionLayout = layouts.find(l => l.name === 'subscriptions')
      return subscriptionLayout.sub_contexts.find(s => s.name === 'decisions-task')
    },

    initialDefinition() {
      return this.layout.definition
    },

    availableElements() {
      return this.layout.available_elements
    },

    defaultWidgets() {
      const defaultWidgets = [
        'usage-development',
        'stakeholder-responses',
        'evaluation-ratings-for-current-and-previous-period'
      ]
      const charts = this.availableElements.filter(widget => defaultWidgets.includes(widget.slug))

      return charts.map(el => ({
        id: el.id,
        type: el.slug,
        colspan: 4,
        name: el.name
      }))
    },

    options() {
      const filteredElements = this.availableElements.filter(el => el.enabled)

      return filteredElements.map(el => ({
        uid: el.id,
        label: el.name,
        name: el.slug
      }))
    }
  },

  async created() {
    await this.$store.dispatch('widgets/getContext')
    this.initDefinition(this.initialDefinition)
  },

  methods: {
    initDefinition(definition) {
      if (definition.length) this.definition = cloneDeep(definition)
      else this.definition = cloneDeep(this.defaultWidgets)
    },

    changeBoxContent({ name }, index) {
      let cards = cloneDeep(this.definition)
      cards[index].type = name
      this.updateLayout(cards)
    },

    updateLayout(definition) {
      apiTo.UPDATE_LAYOUT(this.layout.id, { definition }).then(({ data }) => (this.definition = data.result.definition))
    }
  }
}
</script>
